module.exports = __webpack_public_path__ + "static/img/helpCenter_pricing.f6fa9cb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/helpCenter_pricing.svg
// module id = Hkrl
// module chunks = 1